import {defineField, PreviewConfig} from 'sanity'
import {dotcomDocuments, toSilverseaComUrl} from './dotcom.document'
import {multilingualStringPreview} from '@/lib/multilingualArrayString'

const attributeWithPrefix = (attribute: string, prefix: string | undefined): string => {
  if (prefix) {
    return `${prefix}.${attribute}`
  }
  return attribute
}

export const defaultDotComPreviewConfig = (attributeName?: string): PreviewConfig => {
  return {
    select: {
      dotcomTitle: attributeWithPrefix('title', attributeName),
      dotcomTitleCard: attributeWithPrefix('card.title', attributeName),
      dotcomPath: attributeWithPrefix('metadata.routing.path.en', attributeName),
      dotcomCardMedia: attributeWithPrefix('card.image.asset.url', attributeName),
      dotcomHeroImage: attributeWithPrefix('sections.0.background.asset.url', attributeName),
    },

    prepare: ({dotcomTitle, dotcomTitleCard, dotcomPath, dotcomCardMedia, dotcomHeroImage}) => {
      const media = dotcomHeroImage || dotcomCardMedia

      return {
        title: multilingualStringPreview(dotcomTitleCard) || multilingualStringPreview(dotcomTitle),
        subtitle: toSilverseaComUrl(dotcomPath),
        media: <img width={100} height={100} src={`${media}?w=100&h=100&dpr=2&fit=crop`} />,
      }
    },
  }
}

export default defineField({
  title: 'silversea.com Page',
  name: 'dotcomPage',
  ...dotcomDocuments(['page', 'landingPage', 'requestBrochure']),
})
